import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { NAPSupplierTradeVerification } from '@/libs/fleet-api/services/nap';
import { DatePicker, Divider, Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { FC } from 'react';

type TradeCheckingBouwheerForm = NAPSupplierTradeVerification;

export const useTradeCheckingBouwheerModal = () => {
	return useAsyncModal<TradeCheckingBouwheerForm, TradeCheckingBouwheerForm>();
};

const TradeCheckingBouwheerModal: FC<
	ReturnType<typeof useTradeCheckingBouwheerModal>
> = (props) => {
	const { form, fieldName } = useForm<TradeCheckingBouwheerForm>();

	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onOk={async () => {
				const values = await form.validateFields();
				props.close(values);
			}}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data) {
					form.setFieldsValue(props.data);
				}
			}}
		>
			<FleetTitle>Add Daftar dan Trade Checking Bouwheer/Buyer</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{ span: 4 }}
				wrapperCol={{ span: 20 }}
			>
				<Form.Item
					name={fieldName('id')}
					noStyle
				/>
				<Form.Item
					label="Supplier"
					style={{ marginTop: 20 }}
					name={fieldName('supplierName')}
					rules={[rule.required()]}
				>
					<Input />
				</Form.Item>

				<Divider />

				<Form.Item
					name={fieldName('verificationDate')}
					label="Tanggal"
					getValueProps={(value) => ({
						value: value && dayjs(value),
					})}
					normalize={(value) => value && dayjs(value).utc(true).toISOString()}
					rules={[rule.required()]}
				>
					<DatePicker disabledDate={(now) => now > dayjs()} />
				</Form.Item>

				<Divider />

				<Form.Item
					label="Contact Person"
					style={{ marginTop: 20 }}
					name={fieldName('contactPerson')}
					rules={[rule.required()]}
				>
					<Input />
				</Form.Item>

				<Divider />

				<Form.Item
					label="Hasil"
					style={{ marginTop: 20 }}
					name={fieldName('verificationResult')}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>
			</Form>
		</FleetModal>
	);
};

export default TradeCheckingBouwheerModal;
